// extracted by mini-css-extract-plugin
export default {"root":"ColumnsList_root__f3PjI","header":"ColumnsList_header__VeWlr","item":"ColumnsList_item__C82wS","label":"ColumnsList_label__vJvME"};